import store from '@/store';

export const BLOQUEAR = 'bloquear';
export const PERMITIR = 'permitir';

export const acaoPadraoLoja = () =>
    store.state.configuracoes?.acao_sem_estoque === PERMITIR ? PERMITIR : BLOQUEAR;

export const acaoSemEstoque = item =>
    item?.acao_sem_estoque === BLOQUEAR || item?.acao_sem_estoque === PERMITIR
        ? item.acao_sem_estoque
        : acaoPadraoLoja();

export const bloqueiaVenda = item => acaoSemEstoque(item) === BLOQUEAR;

export const controleEstoqueAtivo = () => !!store.state.configuracoes?.controle_estoque;

export const saldoDisponivel = item => {
    if (!controleEstoqueAtivo() || !item?.controle_estoque || !bloqueiaVenda(item)) {
        return Infinity;
    }

    return +item.estoque || 0;
};

export const esgotado = item => saldoDisponivel(item) <= 0;
